import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from "@ngx-formly/core";
import { ToasterService } from "angular2-toaster";
import { JobOffersService } from "app/services";
import { DP_FORMAT, MAX_EXP_GG } from "app/views/jobOffers/edit-join-offer/exports";
import * as moment from "moment";

@Component({
  selector: "formly-field-update-expiry-date",
  template: `
  <ng-container *ngIf="!field.templateOptions.hidden">
  <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
      <formly-form
        [form]="form"
        [fields]="fields"
        [model]="model"
      ></formly-form>
      <!-- <button type="submit" class="btn btn-default" [disabled]="!form.valid">Submit</button> -->
    </form>
  </ng-container>
    <!-- <input type="input" [formControl]="formControl" [formlyAttributes]="field"> -->
    <!-- <button
      type="submit"
      class="{{
        field.templateOptions.className
          ? field.templateOptions.className
          : 'btn btn-default'
      }}"
      [disabled]="field.templateOptions.disabled || form.invalid"
    >
      {{ field.templateOptions.buttonLabel }}
    </button> -->
    <!-- {{ field.templateOptions.disabled}} -->
  `,
})
export class FormlyFieldUpdateExpiryDate extends FieldType<FieldTypeConfig> implements OnInit {
  public form: FormGroup = new FormGroup({});
  model: any = {
    showErrorState: true,
    isLoading: false,
  };
  public fields: FormlyFieldConfig[] = [];

  constructor(
    private jos: JobOffersService,
    private toaster: ToasterService,
  ) { super() }

  public async onSubmit(model: any) {
    // this.isLoading = true;
    this.model.isLoading = true;
    const { expiration_date } = model;
    await this.jos.updateExpirationDate(this.field.templateOptions.id, expiration_date).toPromise();
    this.model.isLoading = false;
    this.toaster.pop('success', `Job Updated successfully.`);
  }

  ngOnInit(): void {
    this.fields = [
      {
        key: "expiration_date",
        type: "date",
        defaultValue: this.field.templateOptions.expDate || moment().add(1, 'days').format(DP_FORMAT),
        // moment('2022-01-01').format(DP_FORMAT) || expDate,
        validation: {
          show: true,
        },
        expressionProperties: {
          'validation.show': 'model.showErrorState',
        },
        templateOptions: {
          label: "Expiration Date",
          /* eslint-disable */
          /* @ts-ignore */
          _min: moment().add(1, 'days').format(DP_FORMAT),
          /* @ts-ignore */
          _max: moment().add(MAX_EXP_GG, 'days').format(DP_FORMAT),
          /* eslint-enable */
          required: true,
          config: {
            format: DP_FORMAT,
          },
          // disabled: this.isFieldDisabled,

          // type: "text",
          // datepickerPopup: "dd-MMMM-yyyy",
        },
        validators: {
          ip: {
            expression: (c) => {
              return moment(c.value).isSameOrAfter(moment().add(1, 'days').format(DP_FORMAT))
            },
            message: (error, field: FormlyFieldConfig) => `${field.formControl.value} must be grater then today`,
          },
        },
      },
      {
        key: "submit",
        type: "submit",
        templateOptions: {
          buttonLabel: "Save",
          form: this.form,
          className: "btn btn-success btn-block",
        },
        expressionProperties: {
          'templateOptions.disabled': 'model.isLoading',
        },
      },
    ];
  }
}
